import { createSelector } from 'reselect';

import type { ActiveDataSubjectState } from './slice';

/**
 * The selector for the `ActiveDataSubject` state store slice
 */
export const getActiveDataSubjectSlice = (state: any): ActiveDataSubjectState =>
  state.ActiveDataSubject;

/**
 * The selector for the list of data subject's the organization supports
 */
export const selectDataSubjects = createSelector(
  getActiveDataSubjectSlice,
  ({ subjects }) => subjects || [],
);

/**
 * The selector for the currently selected data subject
 */
export const selectActiveDataSubject = createSelector(
  getActiveDataSubjectSlice,
  ({ activeDataSubject, subjects }) =>
    activeDataSubject ||
    (subjects && subjects.length === 1 ? subjects[0] : undefined),
);
